import resolveVariable from './resolve-variable';

const resolveSchemeVariable = ({ varName, definition, scheme, assignVariable }) => {
  const computedValue =
    varName in scheme.variableOverrides
      ? scheme.variableOverrides[varName]
      : scheme.computedRules[definition.rule];

  return resolveVariable({ varName, definition, computedValue, assignVariable });
};

export default resolveSchemeVariable;
